import React from 'react';
import Select from 'react-select';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const Wrapper = styled.div`
  background: ${props => props.theme.colors.white.white};
  margin-top: 1rem;
  padding: 1rem;
  h5 {
    margin: 0 0 1rem 0;
  }
`;

const SidebarCategoriesSelector = ({ categories, onSelect }) => {
  const options = [{
    label: 'All Posts',
    value: 'all-posts'
  }].concat(categories.map(({ name, slug }) => ({ label: name, value: slug })));

  return (
    <Wrapper>
      <h5>Filter by Category</h5>
      {categories &&
        <Select
          options={options}
          defaultValue={options[0]}
          onChange={onSelect}
          theme={theme => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary: '#80CBB4',
              primary25: '#F0F3F4',
              primary50: '#5F5F6E',
              primary75: '#E5E5E5',
              danger: '#C3482C'
            }
          })}
        />
      }
    </Wrapper>
  );
};

export default SidebarCategoriesSelector;

SidebarCategoriesSelector.propTypes = {
  categories: PropTypes.array.isRequired,
  onSelect: PropTypes.any
};
